<template>
    <v-layout row wrap class="rolodex">
        <v-flex xs12 class="text-right rolodex__dropdown-area">
            <v-flex xs12>
                <v-layout wrap class="rolodex__list">
                    <v-flex pr-2 v-if="selectedLetterFilter" class="text-left">
                        <div class="selected-letter">
                            <span class="selected-letter__close">
                            <v-icon data-qe-id="selected_letter_remove_icon"
                                    @click="removeSelectedLetter"
                                    color="black"
                                    size="18">close</v-icon>
                        </span>
                            <span data-qe-id="selected_letter"
                                  class="selected-letter__name">
                            {{selectedLetterFilter.key}}
                        </span>
                        </div>
                    </v-flex>
                    <v-flex pr-4 v-else>
                        <v-layout justify-end>
                            <v-tabs color="white"
                                    class="full-width"
                                    mobile-break-point="600"
                                    :mandatory="false"
                                    hide-slider>
                                <v-tab v-for="letter in filteredLetters"
                                       @click="handleSelectedLetter(letter)"
                                       class="rolodex__letter text-right"
                                       :disabled="letter.disabled"
                                       :data-qe-id="`last-name_letter_${letter.key}`"
                                       :key="letter.key">
                                    {{letter.key}}
                                </v-tab>
                            </v-tabs>
                        </v-layout>
                    </v-flex>
                </v-layout>     
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
    import { memberDirectoryPageConstant, getLettersBasedOnLastName } from './memberDirectoryPage.constants';
    
    export default {
        name: 'Rolodex',
        props: {
            filteredLettersList: {
                type: Array,
                required: true,
            },
            setDirectorySelectedLetter: {
                type: Function,
                required: true,
            },
            resetSelectedLetter: {
                type: Function,
                required: true,
            },
            selectedLetterFilter: {
                type: Object,
            },
        },
        data() {
            return {
                memberDirectoryPageConstant,
            };
        },
        methods: {
            handleSelectedLetter(letter) {
                this.setDirectorySelectedLetter(letter);
            },
            removeSelectedLetter() {
                this.resetSelectedLetter();
            },
        },
        computed: {
            filteredLetters() {
                let result = [];
                if (this.filteredLettersList && this.filteredLettersList.length) {
                    result = [...getLettersBasedOnLastName(this.filteredLettersList)];
                }
               return result;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/colors';
    @import '../../common/styles/commonClasses';

    .rolodex {
        padding-left: 10px;
        padding-right: 10px;

        &__dropdown-area {
            font-size: 16px;
        }

        &__list {
            padding: 5px 0;
        }

        &__label {
            padding-top: 13px;
            max-width: 300px;
            flex: 0 1 auto;
            padding-right: 25px;
        }

        &__letter {
            color: $ypo-cta !important;
        }

        &__alphabet-ribbon {
            padding: 5px 0;
            font-size: 16px;
            font-weight: 600;
            border-bottom: 2px solid $ypo-light-gray;
            border-top: 2px solid $ypo-light-gray;
        }

        &__line-spacing {
            margin-top: 10px;
            margin-bottom: 10px;
        }

        &__bold {
            font-weight: 600;
        }

        &__link {
            text-decoration: none;
            color: $ypo-cta;
        }

        .selected {
            color: $ypo-blue !important;
            font-weight: 600;
            border-bottom: 2px solid $ypo-blue;
        }

        .selected-letter {
            border: 1px solid $ypo-tile-border;
            -webkit-border-radius: 16px;
            -moz-border-radius: 16px;
            border-radius: 16px;
            background-color: $white;
            padding: 5px 10px;
            margin-top: 5px;
            width: 65px;

            &__close {
                color: $black;
                position: relative;
                margin-top: -2px;
            }

            &__name {
                padding-left: 5px;
                font-size: 14px;
                color: $ypo-cta;
            }
        }
    }
</style>

<style lang="scss">
    @import '../../common/styles/colors';

    .rolodex {
        .v-tabs__container {
            justify-content: space-between !important;
        }

        .v-tabs {

            &__wrapper--show-arrows {
                margin-left: 0;
                margin-right: 0;
            }

            &__icon {
                font-size: 34px;
                margin-top: 0;
                color: $ypo-cta;
                font-weight: 600;
                z-index: 100;
                background-color: $white !important;

                &--prev {
                    margin-left: -5px;
                }

                &--next {
                    margin-right: -5px;
                }
            }
            &__div {
                max-width: none;
            }

            &__item {
                opacity: 1 !important;
                color: $ypo-cta !important;

                &--disabled {
                    color: $ypo-blue-grey !important;
                }
            }
        }
    }
</style>
